import { Card } from "antd";
import { Bar } from "react-chartjs-2";
import React, { useMemo } from "react";
import { ChartDataFeedback } from "../../chart-data-feedback";
import { productStageToChart } from "./product-stage-to-chart";
import { useCompaniesByDimensions } from "../use-companies-by-dimensions";
import { PRODUCT_STAGE_CHART_OPTIONS } from "./product-stage-chart-options";

export const ProductStageChart = ({ filters = {} }) => {
  const { loading, results } = useCompaniesByDimensions({
    dimensions: ["companyProductStage"],
    mustBeSet: ["companyProductStage"],
    ...filters
  });

  const chartData = useMemo(() => {
    if (!results) return ({ labels: [], datasets: [] });

    const [result] = results;
    return productStageToChart(result.data);
  }, [results]);

  return (
    <Card
      spaced
      bordered
      style={sectionStyle}
      bodyStyle={{ height: "max-content" }}
      title="Compañías por etapa de producto">
      <ChartDataFeedback
        loading={loading}
        isEmpty={!chartData?.datasets?.length}>
        <Bar
          height={300}
          type={"bar"}
          data={chartData}
          options={PRODUCT_STAGE_CHART_OPTIONS} />
      </ChartDataFeedback>
    </Card>
  );
};

const sectionStyle = {
  marginTop: 16,
  boxShadow: "none",
  borderRadius: "0"
};
